import React, { useState, useEffect } from "react";
import { BinsDataContext } from "./context";

import { getBinsData } from "../services/services";

const BinsProvider = ({ children }) => {
  const [binsData, setBinsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBins = async () => {
      const bins = await getBinsData({ lang: "el" })
        .then((response) => {
          if (response.length > 0) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
        });
      setBinsData(bins);
    };

    fetchBins();
  }, []);

  return (
    <BinsDataContext.Provider value={{ binsData, setBinsData, loading, error }}>
      {children}
    </BinsDataContext.Provider>
  );
};

export default BinsProvider;
